import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBModalTitle,
  MDBBtn,
  MDBIcon,
} from 'mdb-react-ui-kit'
import profilePicGuidelines from './../../../../assets/images/picguidelines.jpg'

const COPY_TEXT = `Turn this into a professional business headshot.
Keep my exact facial features and expression.
Improve lighting and sharpness.
Replace the background with a clean office or neutral backdrop.
Dress me in professional business attire.`

/**
 * GuidelinesModal component - Displays profile picture guidelines
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onToggle - Function to toggle modal visibility
 * @param {Function} props.onClose - Function to call when modal is closed
 * @param {Function} props.onProceed - Function to call when proceed button is clicked (closes modal and opens file picker)
 */
const GuidelinesModal = ({ isOpen, onToggle, onClose, onProceed }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  /**
   * Handles modal close event
   * Calls onClose if provided, otherwise falls back to onToggle
   */
  const handleToggle = () => {
    if (onClose) {
      onClose()
    } else {
      onToggle()
    }
  }

  /**
   * Handles proceed button click
   * Closes the modal and triggers the file picker
   */
  const handleProceed = () => {
    if (onProceed) {
      onProceed()
    }
  }

  return (
    <MDBModal open={isOpen} onClose={handleToggle} tabIndex='-1'>
      <MDBModalDialog size='lg'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle tag='h4'>Profile Pic Guidelines</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={handleToggle}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <img src={profilePicGuidelines} className='img-fluid' alt='Profile guidelines' />
            <div className='mt-4'>
              <p>
                If your picture is low-quality or pixelated, go to{' '}
                <a href='https://chatgpt.com' target='_blank' rel='noopener noreferrer'>
                  chatgpt.com
                </a>
                , upload your picture there, and copy/paste the following prompt:
              </p>
              <div className='p-3 mt-2 grey lighten-4 rounded'>
                <div className='d-flex justify-content-end mb-2'>
                  <CopyToClipboard text={COPY_TEXT} onCopy={handleCopy}>
                    <MDBBtn type='button' color='indigo' size='sm' className='m-0'>
                      <MDBIcon fas icon='copy' className='mr-1' />
                      {copied ? 'Copied!' : 'Copy Prompt'}
                    </MDBBtn>
                  </CopyToClipboard>
                </div>
                <p className='mb-0' style={{ whiteSpace: 'pre-wrap' }}>
                  {COPY_TEXT}
                </p>
              </div>
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            {onProceed && (
              <MDBBtn type='button' color='primary' onClick={handleProceed} className='btn-block'>
                Continue Uploading New Headshot
              </MDBBtn>
            )}
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

GuidelinesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onProceed: PropTypes.func,
}

GuidelinesModal.defaultProps = {
  onClose: null,
  onProceed: null,
}

export default GuidelinesModal
